import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { Supervision, ImageItem, SupervisionError, Flight } from 'solar-bo';
import { DateHelper} from 'shtools';

@Component({
  selector: 'app-imagethermal',
  templateUrl: './imagethermal.component.html',
  styleUrls: ['./imagethermal.component.scss']
})
export class ImageThermalComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() imageurl;
  private _imageItem:ImageItem;
  @Input()  set imageItem(value:ImageItem){
     this._imageItem=value;
     this.configDataByImageItem();
  }  
  get imageItem ():ImageItem {
    return this._imageItem;
  }

  supervision:Supervision;
  title:string="Image";  
  titlesub:string="";
  issue:SupervisionError=null;
  constructor() { 
  
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("IssuecanvasComponent ngOnChanges " ,changes);
    /* let typeChange = changes['issue'];
    if (typeChange && !typeChange.firstChange) {
    } */
  }

  ngAfterViewInit(){

  }

  configDataByImageItem(){
    let img=this._imageItem.tag.image;
    this.title="Image: " + this._imageItem.label + " on " + DateHelper.formatDateTime(img.time);
    let f:Flight=this._imageItem.tag.flight;
    this.titlesub="Flight: " + f.name +" on "+ DateHelper.formatDateTime(f.info.creation_date);
    this.imageurl =this._imageItem.big;
  }

  public static openModalForImage(dialog: MatDialog,supervision:Supervision, imageItem:ImageItem): MatDialogRef<ImageThermalComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "700px";
    //dialogConfig.data = {entity2edit: entity2edit };

    let dialogRef: MatDialogRef<ImageThermalComponent>;
    dialogRef = dialog.open(ImageThermalComponent, dialogConfig);
    dialogRef.componentInstance.title=imageItem.label;
    dialogRef.componentInstance.supervision = supervision;
    dialogRef.componentInstance.imageItem =imageItem;
    return dialogRef;
  }
}
